import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import Settings from "../tabs/Settings";
import typography from "../typography";

export default function SettingsScreen() {
  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_SETTINGS} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_SETTINGS} />
        <Settings />
      </Container>
    </div>
  );
}
